import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs, redirect } from 'react-router';
import { getAuthUser } from '~/shared/auth/auth-utils';
import { assertIsDefined } from '~/types/assert-type';

export const baseRouterLoader =
  (queryClient: QueryClient) =>
  async ({ request }: LoaderFunctionArgs) => {
    const authUser = await getAuthUser(queryClient, request);

    assertIsDefined(authUser);

    return redirect(authUser.defaultRedirectRoute);
  };
